import React, {useEffect, useState} from 'react';
import {
    Container,
    TextField,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    Modal,
    Paper,
    Typography,
    Box,
    Tabs,
    Tab,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';

import {
    TreeView,
    TreeItem
} from '@mui/lab';
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { useMaterialUIController } from "../../context";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// Modal styling using MUI's sx prop
const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflowY: 'auto',
};

// Simple TabPanel component for handling tab content
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`customer-tabpanel-${index}`}
            aria-labelledby={`customer-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

const MasterOperation = () => {
    // Use your MUI controller to detect dark mode.
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [placeDraft, setPlaceDraft] = useState(null);
    // Define style variables based on darkMode
    const pageBackground = darkMode ? "#1A2035" : "#F5F5F5";
    const textColor = darkMode ? "#ffffff" : "#000000";
    const paperBg = darkMode ? "#27293d" : "#ffffff";
    const inputBorderColor = darkMode ? "#666" : "#ccc";
    const [isAddEditOpen, setIsAddEditOpen] = useState(false);
    const blankCustomer = () => ({
        id: Date.now(),           // crude demo id; replace with UUID/DB id later
        name: '',
        phone: '',
        email: '',
        contracts: [],            // we create these in the modal
        billingInfo: [],
        invoices: [],
        parkingPlaces: []
    });
    const [editingCustomer, setEditingCustomer] = useState(null);   // null = “add” mode
    // -------------------------------
    // Mock Data
    // -------------------------------
    const themedTextField = {
        mb: 1,
        color: textColor,
        "& .MuiOutlinedInput-notchedOutline": { borderColor: textColor },
        "& .MuiInputBase-input": { color: textColor },
        "& .MuiInputLabel-root": { color: textColor },
    };

    const updatePlaceContract = (placeIdx, contractIdx, field, value) => {
        setEditingCustomer((prev) => {
            const places = [...prev.parkingPlaces];
            const contracts = [...places[placeIdx].contracts];
            contracts[contractIdx] = { ...contracts[contractIdx], [field]: value };
            places[placeIdx] = { ...places[placeIdx], contracts };
            return { ...prev, parkingPlaces: places };
        });
    };
    const openAdd = () => {
        setEditingCustomer(blankCustomer());
        setIsAddEditOpen(true);
    };
    const startAddPlace = () =>
        setPlaceDraft({ placeId:'', name:'', email:'', revShare:'', contracts:[] });
    const addPlace = () =>
        setEditingCustomer((prev) => ({
            ...prev,
            parkingPlaces: [
                ...prev.parkingPlaces,
                {
                    placeId: '',
                    name: '',
                    email: '',
                    revShare: '',
                    contracts: []
                }
            ]
        }));

    const addContract = (pIdx) =>
        setEditingCustomer((prev) => {
            const places = [...prev.parkingPlaces];
            places[pIdx].contracts.push({
                contractId: '',
                contractType: '',
                details: '',
                items: []
            });
            return { ...prev, parkingPlaces: places };
        });
    const openEdit = (customer) => {
        // deep‑clone so we don’t mutate the list until Save
        const copy = structuredClone(customer); // modern browser clone
        if (!copy.contracts) copy.contracts = [];      // safety
        setEditingCustomer(copy);
        setIsAddEditOpen(true);
    };
    const updateContract = (idx, field, value) => {
        setEditingCustomer((prev) => {
            const newContracts = [...prev.contracts];
            newContracts[idx] = { ...newContracts[idx], [field]: value };
            return { ...prev, contracts: newContracts };
        });
    };

    const closeAddEdit = () => {
        setEditingCustomer(null);
        setIsAddEditOpen(false);
    };

    const saveCustomer = () => {
        setCustomers((prev) => {
            const exists = prev.find((c) => c.id === editingCustomer.id);
            if (exists) {
                // update
                return prev.map((c) => (c.id === editingCustomer.id ? editingCustomer : c));
            }
            // add
            return [...prev, editingCustomer];
        });
        closeAddEdit();
    };
    const initialCustomers = [
        {
            id: 1,
            name: 'Tomer Leon',
            phone: '050-8421-995',
            email: 'leon@blueparking.co.il',
            // For demonstration, assume this contract is active for parking places
            contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly' }],
            billingInfo: [{ billingId: 'B101', amount: 120.75, billingDate: '2023-10-01' }],
            invoices: [{ invoiceId: 'I101', total: 200 , date: '2023-10-01'}],
            parkingPlaces: [
                { placeId: 'P101', name: 'Lot A', address: 'Downtown', revShare: 10 , contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }],},
            ],
        },
        {
            id: 2,
            name: 'Jane Smith',
            phone: '050-5050-505',
            email: 't@g.com',
            contracts: [{ contractId: 'C102', details: 'Another contract detail', contractType: 'monthly' }],
            billingInfo: [{ billingId: 'B102', amount: 230.0, billingDate: '2023-10-01' }],
            invoices: [{ invoiceId: 'I102', total: 400 , date: '2023-10-01'}],
            parkingPlaces: [
                { placeId: 'P102', name: 'רמי לוי אשקלון', address: 'Midtown', revShare: 15, contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }, { contractId: 'C102', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }] },
                { placeId: 'P103', name: 'רמי לוי גבעת שאול', address: 'Midtown', revShare: 15, contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }] },
                { placeId: 'P104', name: 'רמי לוי אשדוד', address: 'Midtown', revShare: 15, contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }] },
                { placeId: 'P105', name: 'רמי לוי יבנה', address: 'Midtown', revShare: 15, contracts: [{ contractId: 'C101', details: 'Contract details here', contractType: 'monthly', items:[{itemName: "A"}, {itemName: "B"}] }] },
            ],
        },
        // Add more mock customers if needed.
    ];

    // -------------------------------
    // State Hooks
    // -------------------------------
    const [customers, setCustomers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [activeTab, setActiveTab] = useState(0); // 0 - Parking, 1 - Contracts, 2 - Billing, 3 - Invoices

    // Paging state
    const [page, setPage] = useState(0);
    const rowsPerPage = 5; // adjust as needed

    // Invoice generation fields
    const [selectedParkingPlace, setSelectedParkingPlace] = useState('');
    const [invoicePeriod, setInvoicePeriod] = useState('');

    // -------------------------------
    // Handlers
    // -------------------------------
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Filter customers by ID or name.
    let filteredCustomers =[];

    const handleOpenCustomerDetails = (customer) => {
        setSelectedCustomer(customer);
        setActiveTab(0); // reset to first tab
    };

    const handleCloseCustomerDetails = () => {
        setSelectedCustomer(null);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleCalculateInvoice = (parkingPlaceId) => {
        console.log('Calculating invoice for parking place:', parkingPlaceId);
        alert('Invoice calculation triggered (demo).');
    };

    const handleGenerateInvoice = () => {
        console.log('Generating invoice with:', {
            parkingPlace: selectedParkingPlace,
            period: invoicePeriod,
        });
        alert('Invoice generation triggered (demo).');
    };

    const handleSendInvoice = () => {
        console.log('Sending invoice...');
        alert('Invoice sending triggered (demo).');
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        (async () => {
            // Simulate fetching data from an API
            const fetchedCustomers = await fetch('http://ec2-51-17-154-245.il-central-1.compute.amazonaws.com:5050/api/Customers');
            console.log(fetchedCustomers)
            const fetchedCustomersData = await fetchedCustomers.json();
            setCustomers(fetchedCustomersData?.data);
            filteredCustomers = customers.filter((customer) =>
                customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.id.toString().includes(searchTerm)
            );
        })();
    }, []);

    // -------------------------------
    // Render
    // -------------------------------
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Container
                sx={{
                    mt: 4,
                    backgroundColor: pageBackground,
                    color: textColor,
                    p: 2,
                    borderRadius: 1,
                }}
            >
                <Typography variant="h4" gutterBottom>
                    Customers Management
                </Typography>

                {/* -----------------------------------------
          1) Search Bar
         ----------------------------------------- */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>

                <TextField
                    label="Search by Name or ID"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={{
                        mb: 3,
                        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                        input: { color: textColor },
                        label: { color: textColor },
                    }}
                />
                    <span>
                    <Button sx={{ml:1}} variant="contained" onClick={openAdd}>
                        Add Customer
                    </Button></span>
                </Box>
                {/* -----------------------------------------
          2) Customers Table with Paging and Colors
         ----------------------------------------- */}
                <Paper sx={{ mb: 4, backgroundColor: paperBg }}>
                    <TableContainer component={Paper} sx={{ backgroundColor: paperBg }}>
                        <Table>
                            <TableHead
                                sx={{
                                    display: 'table-header-group',
                                    backgroundColor: darkMode ? "#1F2739" : "#f0f0f0",
                                }}
                            >
                                <TableRow>
                                    <TableCell sx={{ color: textColor, fontWeight: 'bold', fontSize: '0.95rem' }}>ID</TableCell>
                                    <TableCell sx={{ color: textColor, fontWeight: 'bold', fontSize: '0.95rem' }}>Name</TableCell>
                                    <TableCell sx={{ color: textColor, fontWeight: 'bold', fontSize: '0.95rem' }}>Phone</TableCell>
                                    <TableCell sx={{ color: textColor, fontWeight: 'bold', fontSize: '0.95rem' }}>Email</TableCell>
                                    <TableCell sx={{ color: textColor, fontWeight: 'bold', fontSize: '0.95rem' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ color: textColor }}>
                                {filteredCustomers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((customer) => (
                                        <TableRow key={customer.id}>
                                            <TableCell sx={{ color: textColor }}>{customer.id}</TableCell>
                                            <TableCell sx={{ color: textColor }}>{customer.name}</TableCell>
                                            <TableCell sx={{ color: textColor }}>{customer.phone}</TableCell>
                                            <TableCell sx={{ color: textColor }}>{customer.email}</TableCell>
                                            <TableCell sx={{ color: textColor }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => handleOpenCustomerDetails(customer)}
                                                >
                                                    Details
                                                </Button>

                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ ml: 1 }}
                                                    onClick={() => openEdit(customer)}
                                                >
                                                    Edit
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                {filteredCustomers?.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No customers found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5]}
                        component="div"
                        count={filteredCustomers.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        // sx={{ color: textColor }}
                        showFirstButton
                        showLastButton
                        sx={{
                            // only color the arrows when their button is NOT disabled
                            "& .MuiTablePagination-actions .MuiIconButton-root:not(.Mui-disabled) .MuiSvgIcon-root": {
                                fill: "white",
                            },
                            // keep the rest of your pagination text white too
                            "& .MuiTablePagination-displayedRows, .MuiTablePagination-selectIcon": {
                                color: "white",
                            },
                        }}
                    />
                </Paper>

                {/* -----------------------------------------
          3) Customer Details Modal with Tabs
         ----------------------------------------- */}
                <Dialog sx={{backgroundColor: pageBackground}} open={Boolean(placeDraft)} onClose={() => setPlaceDraft(null)}>
                    <DialogTitle sx={{backgroundColor: pageBackground}}>Add Parking Place</DialogTitle>
                    <DialogContent sx={{backgroundColor: pageBackground}}>
                        <TextField
                            fullWidth
                            label="Place ID"
                            value={placeDraft?.placeId || ''}
                            onChange={(e) =>
                                setPlaceDraft({ ...placeDraft, placeId: e.target.value })
                            }
                            sx={themedTextField}

                            margin="normal"
                        />

                        {/* ---- Name ---- */}
                        <TextField
                            fullWidth
                            label="Name"
                            value={placeDraft?.name || ''}
                            onChange={(e) =>
                                setPlaceDraft({ ...placeDraft, name: e.target.value })
                            }
                            sx={themedTextField}

                            margin="normal"
                        />

                        {/* ---- Address ---- */}
                        <TextField
                            fullWidth
                            label="Address"
                            value={placeDraft?.address || ''}
                            onChange={(e) =>
                                setPlaceDraft({ ...placeDraft, address: e.target.value })
                            }
                            sx={themedTextField}

                            margin="normal"
                        />

                        {/* ---- Revenue‑share percentage ---- */}
                        <TextField
                            fullWidth
                            label="Revenue Share %"
                            type="number"
                            inputProps={{ min: 0, max: 100 }}
                            value={placeDraft?.revShare || ''}
                            onChange={(e) =>
                                setPlaceDraft({ ...placeDraft, revShare: e.target.value })
                            }
                            sx={themedTextField}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions sx={{backgroundColor: pageBackground}}>
                        <Button onClick={() => setPlaceDraft(null)}>Cancel</Button>
                        <Button onClick={() => {
                            setEditingCustomer(prev => ({
                                ...prev,
                                parkingPlaces: [...prev.parkingPlaces, placeDraft]
                            }));
                            setPlaceDraft(null);
                        }}>Add</Button>
                    </DialogActions>
                </Dialog>
                <Modal open={isAddEditOpen} onClose={closeAddEdit}>
                    <Box sx={{ ...styleModal, backgroundColor: paperBg, color: textColor }}>
                        <Typography variant="h5" gutterBottom>
                            {editingCustomer && customers.find((c) => c.id === editingCustomer.id)
                                ? 'Edit Customer'
                                : 'Add Customer'}
                        </Typography>

                        {/* === Basic customer fields === */}
                        <TextField
                            fullWidth
                            label="Name"
                            value={editingCustomer?.name || ''}
                            onChange={(e) =>
                                setEditingCustomer({ ...editingCustomer, name: e.target.value })
                            }
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            fullWidth
                            label="Phone"
                            value={editingCustomer?.phone || ''}
                            onChange={(e) =>
                                setEditingCustomer({ ...editingCustomer, phone: e.target.value })
                            }
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            fullWidth
                            label="Address"
                            value={editingCustomer?.email || ''}
                            onChange={(e) =>
                                setEditingCustomer({ ...editingCustomer, email: e.target.value })
                            }
                            sx={{ mb: 3 }}
                        />

                        {/* === Contracts section === */}
                        <Typography variant="h6" gutterBottom>Contracts</Typography>
                        {editingCustomer?.parkingPlaces.length === 0 && (
                            <Button variant="outlined" onClick={startAddPlace }>
                                + Add Parking Place
                            </Button>
                        )}
                        {editingCustomer?.parkingPlaces.map((place, pIdx) => (
                            <Paper key={place.placeId} sx={{ p: 2, mb: 3, backgroundColor: paperBg }}>
                                <Typography sx={themedTextField} variant="subtitle1" gutterBottom>
                                    {`Place: ${place.placeId} – ${place.name}`}
                                </Typography>
                                {/*{place.contracts.length === 0 && (*/}
                                {/*    <Button variant="outlined" size="small" onClick={() => addContract(pIdx)}>*/}
                                {/*        + Add Contract*/}
                                {/*    </Button>*/}
                                {/*)}*/}

                                {place.contracts.map((ct, cIdx) => (
                                    <Paper key={cIdx} sx={{ p: 2, mb: 2, backgroundColor: paperBg, border: '1px dashed', borderColor: inputBorderColor }}>
                                        <TextField
                                            fullWidth
                                            label="Contract ID"
                                            value={ct.contractId}
                                            onChange={(e) => updatePlaceContract(pIdx, cIdx, 'contractId', e.target.value)}
                                            sx={themedTextField}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Type"
                                            value={ct.contractType}
                                            onChange={(e) => updatePlaceContract(pIdx, cIdx, 'contractType', e.target.value)}
                                            sx={themedTextField}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Details"
                                            value={ct.details}
                                            onChange={(e) => updatePlaceContract(pIdx, cIdx, 'details', e.target.value)}
                                            sx={themedTextField}
                                        />

                                        {/* Items inside this contract */}
                                        <Typography variant="subtitle2" sx={{ mt: 1 , color: textColor}}>Items</Typography>
                                        {ct.items?.map((it, iIdx) => (
                                            <Box key={iIdx} sx={{ display: 'flex', mb: 1 }}>
                                                <TextField
                                                    fullWidth
                                                    label={`Item ${iIdx + 1}`}
                                                    value={it.itemName}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        setEditingCustomer((prev) => {
                                                            const places = [...prev.parkingPlaces];
                                                            places[pIdx].contracts[cIdx].items[iIdx].itemName = val;
                                                            return { ...prev, parkingPlaces: places };
                                                        });
                                                    }}
                                                    sx={themedTextField}
                                                />
                                                <Button
                                                    size="small"
                                                    onClick={() => {
                                                        setEditingCustomer((prev) => {
                                                            const places = [...prev.parkingPlaces];
                                                            places[pIdx].contracts[cIdx].items.splice(iIdx, 1);
                                                            return { ...prev, parkingPlaces: places };
                                                        });
                                                    }}
                                                >
                                                    X
                                                </Button>
                                            </Box>
                                        ))}

                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => {
                                                setEditingCustomer((prev) => {
                                                    const places = [...prev.parkingPlaces];
                                                    if (!places[pIdx].contracts[cIdx].items) places[pIdx].contracts[cIdx].items = [];
                                                    places[pIdx].contracts[cIdx].items.push({ itemName: '' });
                                                    return { ...prev, parkingPlaces: places };
                                                });
                                            }}
                                        >
                                            + Add Item
                                        </Button>
                                    </Paper>
                                ))}

                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setEditingCustomer((prev) => {
                                            const places = [...prev.parkingPlaces];
                                            places[pIdx].contracts.push({ contractId: '', contractType: '', details: '', items: [] });
                                            return { ...prev, parkingPlaces: places };
                                        });
                                    }}
                                >
                                    + Add Contract
                                </Button>
                            </Paper>
                        ))}
                        {/* === Save / Cancel === */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            <Button
                                      variant="outlined" onClick={closeAddEdit}>
                                Cancel
                            </Button>
                            <Button
                                      variant="contained" onClick={saveCustomer}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={Boolean(selectedCustomer)}
                    onClose={handleCloseCustomerDetails}
                    aria-labelledby="customer-details-title"
                >
                    <Box sx={{ ...styleModal, backgroundColor: paperBg, color: textColor }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography id="customer-details-title" variant="h5">
                                Customer Details
                            </Typography>
                            <Button onClick={handleCloseCustomerDetails} variant="outlined">
                                Close
                            </Button>
                        </Box>
                        {selectedCustomer && (
                            <Box sx={{ mt: 2 }}>
                                <Typography>
                                    <strong>Name:</strong> {selectedCustomer.name}
                                </Typography>
                                <Typography>
                                    <strong>ID:</strong> {selectedCustomer.id}
                                </Typography>
                                <Typography>
                                    <strong>Phone:</strong> {selectedCustomer.phone}
                                </Typography>
                                <Typography>
                                    <strong>Email:</strong> {selectedCustomer.email}
                                </Typography>

                                {/* Tabs */}
                                <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
                                    <Tabs
                                        value={activeTab}
                                        onChange={handleTabChange}
                                        aria-label="customer details tabs"
                                        textColor="inherit"
                                        indicatorColor="primary"
                                    >
                                        <Tab label="Parking & Contracts" />
                                        <Tab label="Billing" />
                                        <Tab label="Invoices" />
                                    </Tabs>
                                </Box>

                                {/* Tab Panels */}
                                <TabPanel value={activeTab} index={0}>
                                    <TreeView
                                        defaultCollapseIcon={<ExpandMoreIcon />}
                                        defaultExpandIcon={<ChevronRightIcon />}
                                    >
                                        {selectedCustomer.parkingPlaces.map((place, i) => (
                                            <TreeItem
                                                key={place.placeId}
                                                nodeId={`${place.placeId}-parent`}
                                                label={`Place: ${place.placeId} - ${place.name}`}
                                            >
                                                {/* Place details nested under the place node */}
                                                <TreeItem
                                                    nodeId={`${place.placeId}-details`}
                                                    label={`Address: ${place.address} | RevShare: ${place.revShare}%`}
                                                />

                                                {/* Contracts sub-branch */}
                                                <TreeItem nodeId={`${place.placeId}-contracts`} label={`Contracts (${place.contracts.length})`}>
                                                    {place.contracts.map((contract, j) => (
                                                        <TreeItem
                                                            key={contract.contractId}
                                                            nodeId={`${place.placeId}-contract-${j}`}
                                                            label={`Contract: ${contract.contractId}`}
                                                        >
                                                            {/* Contract details */}
                                                            <TreeItem
                                                                nodeId={`${place.placeId}-contract-${j}-details`}
                                                                label={`Type: ${contract.contractType} | ${contract.details}`}
                                                            />
                                                            {/* Items */}
                                                            {contract.items && contract.items.length > 0 && (
                                                                <TreeItem
                                                                    nodeId={`${place.placeId}-contract-${j}-items`}
                                                                    label="Items"
                                                                >
                                                                    {contract.items.map((item, k) => (
                                                                        <TreeItem
                                                                            key={k}
                                                                            nodeId={`${place.placeId}-contract-${j}-item-${k}`}
                                                                            label={item.itemName}
                                                                        />
                                                                    ))}
                                                                </TreeItem>
                                                            )}
                                                        </TreeItem>
                                                    ))}
                                                </TreeItem>
                                            </TreeItem>
                                        ))}
                                    </TreeView>
                                </TabPanel>

                                <TabPanel value={activeTab} index={1}>
                                    <Typography variant="h6" gutterBottom>
                                        Billing
                                    </Typography>
                                    {selectedCustomer.billingInfo && selectedCustomer.billingInfo.length > 0 ? (
                                        selectedCustomer.billingInfo.map((bill) => (
                                            <Paper key={bill.billingId} sx={{ p: 2, mb: 2, backgroundColor: paperBg }}>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Billing ID:</strong> {bill.billingId}
                                                </Typography>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Amount:</strong> ${bill.amount}
                                                </Typography>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Billing period:</strong> {bill.billingDate}
                                                </Typography>
                                            </Paper>
                                        ))
                                    ) : (
                                        <Typography>No billing records available.</Typography>
                                    )}
                                </TabPanel>

                                <TabPanel value={activeTab} index={2}>
                                    <Typography variant="h6" gutterBottom>
                                        Invoices
                                    </Typography>
                                    {selectedCustomer.invoices && selectedCustomer.invoices.length > 0 ? (
                                        selectedCustomer.invoices.map((inv) => (
                                            <Paper key={inv.invoiceId} sx={{ p: 2, mb: 2, backgroundColor: paperBg }}>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Invoice ID:</strong> {inv.invoiceId}
                                                </Typography>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Total:</strong> ${inv.total}
                                                </Typography>
                                                <Typography sx={{ color: textColor }}>
                                                    <strong>Date:</strong> {inv.date}
                                                </Typography>
                                            </Paper>
                                        ))
                                    ) : (
                                        <Typography>No invoices found.</Typography>
                                    )}

                                    <Box sx={{ mt: 3 }}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Generate New Invoice
                                        </Typography>
                                        <FormControl fullWidth sx={{ mb: 2 }}>
                                            <InputLabel id="parking-place-label">Parking Place</InputLabel>
                                            <Select
                                                labelId="parking-place-label"
                                                value={selectedParkingPlace}
                                                label="Parking Place"
                                                onChange={(e) => setSelectedParkingPlace(e.target.value)}
                                            >
                                                <MenuItem value="">
                                                    <em>Select a parking place</em>
                                                </MenuItem>
                                                {(selectedCustomer.parkingPlaces || []).map((place) => (
                                                    <MenuItem key={place.placeId} value={place.placeId}>
                                                        {place.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            fullWidth
                                            label="Period"
                                            placeholder="e.g. Jan 2025"
                                            variant="outlined"
                                            value={invoicePeriod}
                                            onChange={(e) => setInvoicePeriod(e.target.value)}
                                            sx={{
                                                mb: 2,
                                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                                input: { color: textColor },
                                                label: { color: textColor },
                                            }}
                                        />
                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                            <Button variant="contained" onClick={handleGenerateInvoice}>
                                                Generate Invoice
                                            </Button>
                                            <Button variant="outlined" onClick={handleSendInvoice}>
                                                Send to Customer
                                            </Button>
                                        </Box>
                                    </Box>
                                </TabPanel>
                            </Box>
                        )}
                    </Box>
                </Modal>
            </Container>
        </DashboardLayout>
    );
};

export default MasterOperation;
